/* eslint-disable max-len */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Promise from 'bluebird';
import _ from 'underscore';
import { Carousel } from '@bingads-webui-react/primitive-unthemed';
import { getPreview } from '../image-preview/preview-factory';
import { MultiImageGeneral } from '../image-preview/multi-image-general';
import getCroppedImage from '../util/get-cropped-image';
import getGenericImageObjectAsync from '../util/get-generic-image-object';
import { ImageExperienceImage } from '../model/image-experience-image';
import C from '../constants';

const CarouselPreview133x100 = (props) => {
  const [index, setIndex] = useState(0);
  const [multiImageList, setMultiImageList] = useState([]);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const imagesToSetup = [
    props.genericImage,
    ...props.placeHolderImages,
  ];

  const setupPromises = _.map(imagesToSetup, imageToSetup => getGenericImageObjectAsync(imageToSetup).then((imageObj) => {
    const croppedImages = getCroppedImage({ originalImageToCrop: imageObj });

    return croppedImages;
  }));

  Promise.all(setupPromises).then(([defaultImages, placeHolderImages1, placeHolderImages2]) => {
    const newMultiImageList = [];
    newMultiImageList.push(props.image);
    const placeHolderImages = [placeHolderImages1 || defaultImages, placeHolderImages2 || defaultImages];

    placeHolderImages.forEach((imageObjs, idx) => {
      const image133x100 = _.find(imageObjs, img => img.type === C.aspectRatios.Image133x100.type);
      const cloned = image133x100.clone();

      cloned.id = cloned.id ? cloned.id + idx : idx;
      newMultiImageList.push(cloned);
    });

    if (multiImageList.length < 3) {
      setMultiImageList(newMultiImageList);
    } else if (
      multiImageList[0].cropSettings.SourceHeight !== newMultiImageList[0].cropSettings.SourceHeight ||
      multiImageList[0].cropSettings.SourceWidth !== newMultiImageList[0].cropSettings.SourceWidth ||
      multiImageList[0].cropSettings.SourceX !== newMultiImageList[0].cropSettings.SourceX ||
      multiImageList[0].cropSettings.SourceY !== newMultiImageList[0].cropSettings.SourceY
    ) {
      setMultiImageList(newMultiImageList);
    }
  });

  return (
    <Carousel
      className="edit-carousel-container"
      activeIndex={index}
      onSelect={handleSelect}
      controls={false}
    >
      <Carousel.Item>
        <MultiImageGeneral
          images={multiImageList}
          i18n={props.i18n}
          previewTexts={props.previewTexts}
          previewType="MobileMultiImage"
        />
      </Carousel.Item>
      <Carousel.Item>
        <MultiImageGeneral
          images={multiImageList}
          i18n={props.i18n}
          previewTexts={props.previewTexts}
          previewType="BingDesktopImage"
        />
      </Carousel.Item>
      <Carousel.Item>
        {getPreview(
          props.image,
          props.previewTexts,
          props.i18n
        )}
      </Carousel.Item>
    </Carousel>
  );
};

CarouselPreview133x100.propTypes = {
  previewTexts: PropTypes.shape({
    longHeadline: PropTypes.string,
    description: PropTypes.string,
    businessName: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
  image: PropTypes.instanceOf(ImageExperienceImage).isRequired,
  genericImage: PropTypes.string.isRequired,
  placeHolderImages: PropTypes.arrayOf(PropTypes.string),
};

CarouselPreview133x100.defaultProps = {
  placeHolderImages: [],
};


export { CarouselPreview133x100 };
